import React, { useState } from "react";
import { Button, Modal } from "carbon-components-react";
import { Renew16 } from "@carbon/icons-react";
import APIClient from "@eave/borrower/web_modules/APIClient";

interface Props {
  loanApplicationId: number;
  isArchived: boolean;
  loadApp: (appID: number) => void;
}

function reloadCreditReport(appID: number): Promise<any> {
  return APIClient.get(`/${appID}/reload_credit_report`);
}

const OrderNewCreditReport: React.FC<Props> = ({
  loanApplicationId,
  isArchived,
  loadApp,
}: Props) => {
  const [showCreditReportErrorModal, setShowCreditReportErrorModal] = useState(false);
  const [showCreditReportWarningModal, setShowCreditReportWarningModal] = useState(false);

  const verifyOrderCreditReport = () => {
    if (isArchived) {
      setShowCreditReportErrorModal(true);
    } else {
      setShowCreditReportWarningModal(true);
    }
  };

  const orderNewCreditReport = () => {
    reloadCreditReport(loanApplicationId)
      .catch(_ => {
        alert(
          `there was an error reloading the credit report, please contact engineering or reload the page and try again`,
        );
      })
      .finally(() => {
        setShowCreditReportWarningModal(false);
        loadApp(loanApplicationId);
      });
  };

  return (
    <>
      <Button
        kind="tertiary"
        onClick={verifyOrderCreditReport}
        renderIcon={Renew16}
        style={{ marginLeft: "10px" }}
      >
        Order New Credit Report
      </Button>
      <Modal
        open={showCreditReportWarningModal}
        modalHeading="Warning!"
        primaryButtonText="Order New Credit Report"
        secondaryButtonText="Cancel"
        onBlur={() => setShowCreditReportWarningModal(false)}
        onRequestClose={() => setShowCreditReportWarningModal(false)}
        onRequestSubmit={() => orderNewCreditReport()}
        danger
      >
        This will overwrite any changes and overrides made on this page. Are you sure you want to
        order a new credit report?
      </Modal>
      <Modal
        open={showCreditReportErrorModal}
        modalHeading="Cannot Order New Credit Report"
        primaryButtonText="Ok"
        onBlur={() => setShowCreditReportErrorModal(false)}
        onRequestClose={() => setShowCreditReportErrorModal(false)}
        onRequestSubmit={() => setShowCreditReportErrorModal(false)}
        danger
      >
        New Credit Reports cannot be ordered for archived loan applications. The application must be
        cloned or the borrower must reapply.
      </Modal>
    </>
  );
};

export default OrderNewCreditReport;
